import { Theme, base, rem, radius, token } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { baseStyles } from '../media-player.styles';
import { tagName } from '../../../helpers';

export const tag = tagName('audio-inline-player');
const theme = new Theme(tag);

export const styles = [
  base.focus,
  baseStyles,
  css`
    :where(.player-container) {
      /* Hide the original player, we're just using the audio */
      display: none;
    }

    :host {
      display: inline-block;
    }

    :where(.button) {
      cursor: pointer;
      display: inline-grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
      place-items: center;
      vertical-align: bottom;

      ${theme.props([
        ['border', 'border', 'none'],
        ['inline-size', 'inline-size', rem(32)],
        ['block-size', 'block-size', rem(32)],
        ['border-radius', 'border-radius', radius('small')],
        ['background', 'background', token('background-secondary')],
        ['box-shadow', 'box-shadow', 'var(--tm-elevation-shadow-raised)'],
        ['color', 'color', token('foreground-primary')],
        ['font-size', 'font-size', rem(16)],
        [
          'transition',
          'transition',
          'color var(--tm-transition-duration-fast) var(--tm-transition-function-ease-out)',
        ],
      ])}
    }

    @media (hover: hover) {
      :where(.button):hover {
        ${theme.props([
          [
            'color',
            'color-hover',
            token('albert-audio-inline-player-foreground-highlighted'),
          ],
        ])}
      }
    }

    :where(.button):not(:hover):is(.playing, .idle) {
      ${theme.props([
        [
          'color',
          'color-playing-or-idle',
          token('albert-audio-inline-player-foreground-highlighted'),
        ],
      ])}
    }

    :where(.icon) {
      grid-column: 1;
      grid-row: 1;
    }
  `,
];
